export class User {
  id: number;
  personId: number;
  username: string;
  password: string;
  createAt: string;
  sentCreds: number;
  sentCredsAt: number;
  active: number;
  twoFactorAuthentication: boolean;
}
